type TgWebApp = {
  initData: string;
  initDataUnsafe: { user?: { id: number; username?: string; first_name?: string; last_name?: string } };
  ready: () => void;
  expand: () => void;
  themeParams: Record<string, string>;
  colorScheme: "light" | "dark";
  showAlert: (msg: string) => void;
  openLink: (url: string, options?: { try_instant_view?: boolean }) => void;
  openTelegramLink: (url: string) => void;
  openInvoice: (url: string, cb?: (status: "paid" | "cancelled" | "failed" | "pending") => void) => void;
  HapticFeedback?: { impactOccurred: (style: "light" | "medium" | "heavy") => void };
  MainButton: { setText: (t: string) => void; show: () => void; hide: () => void; onClick: (cb: () => void) => void; offClick: (cb: () => void) => void };
  BackButton: { show: () => void; hide: () => void; onClick: (cb: () => void) => void; offClick: (cb: () => void) => void };
};

declare global {
  interface Window {
    Telegram?: { WebApp: TgWebApp };
  }
}

export function tg(): TgWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function initTelegram() {
  const app = tg();
  if (!app) return;
  app.ready();
  app.expand();
}

export function getInitData(): string {
  const app = tg();
  if (app && app.initData) return app.initData;
  // Dev fallback: if running outside Telegram, return empty string.
  // The bot's /api/session will reject empty initData with 401, which is correct.
  return "";
}
